import Vue from 'vue'

export var bus = new Vue({
    methods: {
        ShowProduct() {
            this.$emit('ShowProduct')
        },
        ShowProductEdit(id) {
            this.$emit('ShowProductEdit', id)
        }
        ,
        GetAllProduct(response, value) {
            this.$emit('GetAllProduct', response, value)
        },
        GetAllProductSku(response) {
            this.$emit('GetAllProductSku', response)
        },
        GetAllCategory(response) {
            this.$emit('GetAllCategory', response)
        },
        GetAllProductType(response) {
            this.$emit('GetAllProductType', response)
        },
        GetAllUnitType(response) {
            this.$emit('GetAllUnitType', response)
        },
        ResponseCreateProduct(response) {
            this.$emit('ResponseCreateProduct', response)
        },
        ResponseCreateProductSku(response) {
            this.$emit('ResponseCreateProductSku', response)
        },
        ResponseCreateProductInventory(response) {
            this.$emit('ResponseCreateProductInventory', response)
        },
        ResponseCreateProductSkuGalery(response) {
            this.$emit('ResponseCreateProductSkuGalery', response)
        },
        ResponseUpdateProduct(response) {
            this.$emit('ResponseUpdateProduct', response)
        },
        ResponseUpdateProductSku(response) {
            this.$emit('ResponseUpdateProductSku', response)
        },
        ResponseUpdateProductInventory(response) {
            this.$emit('ResponseUpdateProductInventory', response)
        },
        ResponseDeleteProduct(response) {
            this.$emit('ResponseDeleteProduct', response)
        },
        GetAllProductPagination(response) {
            this.$emit('GetAllProductPagination', response)
        },
        GetAllProductAll(response) {
            this.$emit('GetAllProductAll', response)
        },
        ResponseCreateCategory(response) {
            this.$emit('ResponseCreateCategory', response)
        },
        GetExportProduct(response) {
            this.$emit('GetExportProduct', response)
        },
        ImportProducts(response){
            this.$emit('ImportProducts', response)
        }

    }
})